var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchInputIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39394 1.09091C3.01744 1.09091 1.09091 3.01744 1.09091 5.39394C1.09091 7.77044 3.01744 9.69697 5.39394 9.69697C6.55496 9.69697 7.60858 9.23716 8.38264 8.48971C8.3977 8.46978 8.41432 8.45065 8.43249 8.43249C8.45065 8.41432 8.46978 8.3977 8.48971 8.38264C9.23716 7.60858 9.69697 6.55496 9.69697 5.39394C9.69697 3.01744 7.77044 1.09091 5.39394 1.09091ZM9.57429 8.8029C10.3329 7.87376 10.7879 6.68698 10.7879 5.39394C10.7879 2.41495 8.37293 0 5.39394 0C2.41495 0 0 2.41495 0 5.39394C0 8.37293 2.41495 10.7879 5.39394 10.7879C6.68698 10.7879 7.87376 10.3329 8.8029 9.57429L11.0689 11.8402C11.2819 12.0533 11.6272 12.0533 11.8402 11.8402C12.0533 11.6272 12.0533 11.2819 11.8402 11.0689L9.57429 8.8029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInputIconWhite);
export default __webpack_public_path__ + "static/media/searchInputIconWhite.edcdc4583e53d75da7cd7caa3bc761d1.svg";
export { ForwardRef as ReactComponent };